export default __webpack_public_path__ + "static/media/save-for-children-icon.cdb087d4.svg";